import { KeyEnum, DisplayMapper } from '../OptionConstant';
const commonApplyStatus = {};
for (let name in KeyEnum.YtcommonApplyStatus) {
  commonApplyStatus[name] = parseInt(KeyEnum.YtcommonApplyStatus[name], 10);
}
export default {
  claculateExpirationStatus(status) {
    status = parseInt(status);
    if ((status & commonApplyStatus.FORMAL_AUTH_OVER) === commonApplyStatus.FORMAL_AUTH_OVER) {
      return true;
    }
    if (((status & commonApplyStatus.AUTH_OVER) === commonApplyStatus.AUTH_OVER) && ((status & commonApplyStatus.FORMAL_VERIFY_SUCCESS) !== commonApplyStatus.FORMAL_VERIFY_SUCCESS)) {
      return true;
    }
    return false;

    //
  },
  isDeviceEditable(status, item) {
    status = parseInt(status);
    let isrenewal = parseInt((item && item.isrenewal) ? item.isrenewal : 0);
    if ((status & commonApplyStatus.FORMAL_VERIFY_SUCCESS) === commonApplyStatus.FORMAL_VERIFY_SUCCESS &&
    (status & commonApplyStatus.FORMAL_AUTH_OVER) === 0) {
      return true;
    }
    if ((status & commonApplyStatus.VERIFYING) === commonApplyStatus.VERIFYING && isrenewal === 1) {
      if (item && item.expired) {
        return false;
      }
      return true;
    }
    if ((status & commonApplyStatus.FORMAL_VERIFYING) === commonApplyStatus.FORMAL_VERIFYING &&
      isrenewal === 1 &&
      (status & commonApplyStatus.AUTH_OVER) !== commonApplyStatus.AUTH_OVER) {
      if (item && item.expired) {
        return false;
      }
      return true;
    }
    if (((status & commonApplyStatus.FORMAL_VERIFY_FAIL) === commonApplyStatus.FORMAL_VERIFY_FAIL || (status & commonApplyStatus.VERIFY_FAIL) === commonApplyStatus.VERIFY_FAIL) &&
      isrenewal === 1) {
      if (item && item.expired) {
        return false;
      }
      return true;
    }
    if ((status & commonApplyStatus.VERIFYING) === commonApplyStatus.VERIFYING ||
        (status & commonApplyStatus.VERIFY_FAIL) === commonApplyStatus.VERIFY_FAIL ||
        (status & commonApplyStatus.AUTH_OVER) === commonApplyStatus.AUTH_OVER ||
        (status & commonApplyStatus.FORMAL_AUTH_OVER) === commonApplyStatus.FORMAL_AUTH_OVER) {
      return false;
    }
    if ((status & commonApplyStatus.VERIFY_SUCCESS) === commonApplyStatus.VERIFY_SUCCESS) {
      return true;
    }
    return false;
  },
  isDeviceVisible(status, isrenewal) {
    status = parseInt(status);
    isrenewal = parseInt(isrenewal);
    if (status === commonApplyStatus.STOP) {
      return false;
    }
    if ((status & commonApplyStatus.VERIFYING) === commonApplyStatus.VERIFYING) {
      if (isrenewal === 1) {
        return true;
      }
      return false;
    }
    if ((status & commonApplyStatus.VERIFY_FAIL) === commonApplyStatus.VERIFY_FAIL) {
      if (isrenewal === 1) {
        return true;
      }
      return false;
    }
    // // 直接申请正式
    if (status === commonApplyStatus.FORMAL_VERIFYING) {
      if (isrenewal === 1) {
        return true;
      }
      return false;
    }

    // 直接正式申请的审核失败，也不显示device list
    if (status === commonApplyStatus.FORMAL_VERIFY_FAIL) {
      if (isrenewal === 1) {
        return true;
      }
      return false;
    }
    return true;
  },
  containStatus(status, range) {
    status = parseInt(status);
    for (let i = 0; i < range.length; i++) {
      let auth = parseInt(range[i]);
      if ((status & auth) === auth) {
        return true;
      }
    }
    return false;
  },
  calculateStyle(status, styleClazz) {
    status = parseInt(status);
    if ((status & commonApplyStatus.FORMAL_AUTH_OVER) === commonApplyStatus.FORMAL_AUTH_OVER) {
      return styleClazz[0];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFY_FAIL) === commonApplyStatus.FORMAL_VERIFY_FAIL) {
      return styleClazz[2];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFY_SUCCESS) === commonApplyStatus.FORMAL_VERIFY_SUCCESS) {
      return styleClazz[1];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFYING) === commonApplyStatus.FORMAL_VERIFYING) {
      return styleClazz[0];
    }
    if ((status & commonApplyStatus.AUTH_OVER) === commonApplyStatus.AUTH_OVER) {
      return styleClazz[0];
    }
    if ((status & commonApplyStatus.VERIFY_FAIL) === commonApplyStatus.VERIFY_FAIL) {
      return styleClazz[2];
    }
    if ((status & commonApplyStatus.VERIFY_SUCCESS) === commonApplyStatus.VERIFY_SUCCESS) {
      return styleClazz[1];
    }
    if ((status & commonApplyStatus.VERIFYING) === commonApplyStatus.VERIFYING) {
      return styleClazz[0];
    }
    if ((status & commonApplyStatus.DELETED) === commonApplyStatus.DELETED) {
      return styleClazz[0];
    }
    if ((status & commonApplyStatus.STOP) === commonApplyStatus.STOP) {
      return styleClazz[0];
    }
    return '';
  },
  displayText(status) {
    status = parseInt(status);
    if ((status & commonApplyStatus.FORMAL_AUTH_OVER) === commonApplyStatus.FORMAL_AUTH_OVER) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.FORMAL_AUTH_OVER];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFY_FAIL) === commonApplyStatus.FORMAL_VERIFY_FAIL) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.FORMAL_VERIFY_FAIL];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFY_SUCCESS) === commonApplyStatus.FORMAL_VERIFY_SUCCESS) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.FORMAL_VERIFY_SUCCESS];
    }
    if ((status & commonApplyStatus.FORMAL_VERIFYING) === commonApplyStatus.FORMAL_VERIFYING) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.FORMAL_VERIFYING];
    }
    if ((status & commonApplyStatus.AUTH_OVER) === commonApplyStatus.AUTH_OVER) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.AUTH_OVER];
    }
    if ((status & commonApplyStatus.VERIFY_FAIL) === commonApplyStatus.VERIFY_FAIL) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.VERIFY_FAIL];
    }
    if ((status & commonApplyStatus.VERIFY_SUCCESS) === commonApplyStatus.VERIFY_SUCCESS) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.VERIFY_SUCCESS];
    }
    if ((status & commonApplyStatus.VERIFYING) === commonApplyStatus.VERIFYING) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.VERIFYING];
    }
    if ((status & commonApplyStatus.STOP) === commonApplyStatus.STOP) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.STOP];
    }
    if ((status & commonApplyStatus.DELETED) === commonApplyStatus.DELETED) {
      return DisplayMapper.COMMON_APPLY_STATUS[commonApplyStatus.DELETED];
    }
    return '';
  },
  calculateTitleStyle(isTestApply) {
    if (isTestApply) {
      return true;
    }
  },
  calculateRenewal(status, isrenewal) {
    status = parseInt(status);
    if (status & commonApplyStatus.VERIFYING === commonApplyStatus.VERIFYING || status & commonApplyStatus.FORMAL_VERIFYING === commonApplyStatus.FORMAL_VERIFYING) {
      return false;
    }
    if (status === commonApplyStatus.VERIFY_FAIL || status === commonApplyStatus.FORMAL_VERIFY_FAIL) {
      if (isrenewal === 1) {
        return true;
      }
      return false;
    }
    return true;
  },
  calculateProductStyle(status, isrenewal, applytype) {
    status = parseInt(status);
    if (applytype === ApplyType.TEST) {
      if ((status === commonApplyStatus.VERIFY_FAIL) && isrenewal !== 1) {
        return false;
      }
      return true;
    }
    if (((status & commonApplyStatus.FORMAL_VERIFY_FAIL) === commonApplyStatus.FORMAL_VERIFY_FAIL) && status !== commonApplyStatus.FORMAL_VERIFY_FAIL && isrenewal !== 1) {
      return true;
    }
    return false;
  }
};
const ApplyType = {
  TEST: 1,
  PRO: 2
};



// WEBPACK FOOTER //
// ./src/common/applyStatusHelper/CommonStatusHelper.js